






























































































































































































































import { Component, Prop, Ref, Vue, Watch } from "vue-property-decorator";
import RisikoJatuh from "@/components/pemeriksaan/assesmen/RisikoJatuh.vue";
import TimeStamp from "@/components/pemeriksaan/assesmen/TimeStamp.vue";
import PerawatAutoComplete from "@/components/pemeriksaan/assesmen/PerawatAutoComplete.vue";
import { userModule } from "@/store/modules/user";
import { storePasien } from "@/store/modules/pasien";
import TekananDarah from "@/components/pemeriksaan/assesmen/TekananDarah.vue";
import CardOdontogram from "@/components/pemeriksaan/assesmen/asesmengigi/CardOdontogram.vue";
import DataAsesmenGigi from "@/services/DataAsesmenGigi";
import { appModule } from "@/store/modules/app";
import { storeAsesmenGigi } from "@/store/modules/asesmengigi";
import http from "@/axios/http-common";
import { storePerawat } from "@/store/modules/perawat";

@Component({
  components: {
    RisikoJatuh,
    PerawatAutoComplete,
    TimeStamp,
    TekananDarah,
    CardOdontogram
  },
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class CardAsesmenGigiMulut extends Vue {
  @Ref() cardOdontogram!: InstanceType<typeof CardOdontogram>;
  @Prop() register!: string;
  @Prop() rm!: string;
  isReadOnly!: () => boolean;

  get readOnly(): boolean {
    return this.isReadOnly();
  }
  time = new Date()
    .toLocaleString("en-CA", { hour12: false, timeZone: "Asia/Jakarta" })
    .toString()
    .substr(12, 8);
  maxDate = new Date().toISOString().substr(0, 10);
  today = new Date().toISOString().substr(0, 10);
  waktu = this.today + " " + this.time;
  perawat = {};
  td = {};

  loadingSimpan = false;
  saving = false;
  golongan_darah = "";

  mounted() {
    this.waktu = this.today + " " + this.time;
  }

  setTd(val) {
    this.stateAsesmenGigi["data_medis"].sistole = val[0];
    this.stateAsesmenGigi["data_medis"].diastole = val[1];
  }

  get sessLogin() {
    return userModule.user;
  }

  get statePasien() {
    return storePasien.identitasPasien;
  }

  get stateAsesmenGigi() {
    return storeAsesmenGigi.asesmenGigi;
  }

  get listKaryawan() {
    return storePerawat.listKaryawan;
  }

  get isAsesmenSigned(): boolean {
    const s: any = this.stateAsesmenGigi;
    return !!(s && (s.is_signed || s.signed_at));
  }

  save() {
    const form = this.$refs.form as Vue & {
      validate: () => boolean;
      inputs: any[];
    };
    if (!form.validate()) {
      const firstError = (form.inputs || [])
        .flatMap(i => i.errorBucket || [])
        .find(Boolean);
      appModule.NoticeDelayAlert(
        firstError || "Lengkapi kolom yang wajib diisi sebelum menyimpan"
      );
      return;
    }
    if (this.saving) return;

    const asObj = (v: any) =>
      v && typeof v === "object" ? v : { id: null, ket: "", ket_lain: "" };

    const diastema = asObj(this.stateAsesmenGigi["diastema"]);
    const gigi_anomali = asObj(this.stateAsesmenGigi["gigi_anomali"]);

    if (String(diastema.id) !== "2") diastema.ket_lain = "";
    if (String(gigi_anomali.id) !== "2") gigi_anomali.ket_lain = "";

    const dokter = this.stateAsesmenGigi["dokter"];
    const user = this.stateAsesmenGigi["user"];
    if (!dokter?.id) {
      appModule.NoticeDelayAlert("Dokter Pemeriksa belum dipilih");
      return;
    }
    if (!user?.id) {
      appModule.NoticeDelayAlert("Petugas belum dipilih");
      return;
    }

    const odontogram_lain = {
      oklusi: this.stateAsesmenGigi["oklusi"],
      torus_palatinus: this.stateAsesmenGigi["torus_palatinus"],
      torus_mandibularis: this.stateAsesmenGigi["torus_mandibularis"],
      palatum: this.stateAsesmenGigi["palatum"],
      diastema: {
        id: diastema.id,
        ket: diastema.ket,
        ket_lain: diastema.ket_lain
      },
      gigi_anomali: {
        id: gigi_anomali.id,
        ket: gigi_anomali.ket,
        ket_lain: gigi_anomali.ket_lain
      },
      lain_lain: this.stateAsesmenGigi["lain_lain"],
      d: this.stateAsesmenGigi["d"],
      m: this.stateAsesmenGigi["m"],
      f: this.stateAsesmenGigi["f"],
      jml_photo: this.stateAsesmenGigi["jml_photo"],
      jenis_photo: this.stateAsesmenGigi["jenis_photo"],
      jml_rontgen: this.stateAsesmenGigi["jml_rontgen"],
      jenis_rontgen: this.stateAsesmenGigi["jenis_rontgen"]
    };

    this.saving = true;
    // Persist odontogram (tooth exams) bersamaan dengan Simpan asesmen —
    // tidak lagi auto-save tiap klik gigi. persist() self-guard pada flag dirty.
    this.cardOdontogram?.persist();
    const isCreate = this.stateAsesmenGigi["id"] == null;
    const dt = isCreate
      ? DataAsesmenGigi.saveDataAsesmenGigi(
          this.today,
          this.register,
          this.rm,
          this.stateAsesmenGigi["data_medis"],
          odontogram_lain,
          dokter.id,
          user.id
        )
      : DataAsesmenGigi.editDataAsesmenGigi(
          this.stateAsesmenGigi["id"],
          this.today,
          this.register,
          this.rm,
          this.stateAsesmenGigi["data_medis"],
          odontogram_lain,
          dokter.id,
          user.id
        );

    dt.then(
      (resp: {
        status?: string | number;
        message?: string;
        data?: { message?: string };
      }) => {
        appModule.setLoading(false);
        if (resp && String(resp.status) === "1") {
          storeAsesmenGigi.actAsesmenGigiByReg(this.register);
          appModule.NoticeDelay(
            isCreate
              ? "Berhasil Simpan Asesmen Gigi dan Mulut"
              : "Berhasil Edit Asesmen Gigi dan Mulut"
          );
        } else {
          const msg =
            resp?.data?.message ||
            resp?.message ||
            "Gagal menyimpan Asesmen Gigi dan Mulut";
          appModule.NoticeDelayAlert(msg);
        }
      }
    )
      .catch(err => {
        console.error("[CardAsesmenGigiMulut] save failed", err);
        appModule.NoticeDelayAlert("Gagal menyimpan Asesmen Gigi dan Mulut");
      })
      .finally(() => {
        this.saving = false;
      });
  }

  cetak() {
    const routeData =
      http.getAPI() +
      "/asesmen-awal-gigi-mulut/" +
      this.stateAsesmenGigi["id"] +
      "/pdf";
    window.open(routeData, "_blank");
  }

  setPerawat(val) {
    this.stateAsesmenGigi["user"] = val;
  }
}
